import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'react-emotion'
import { fontWeights, colors } from 'shared/ui/theme'
import { avatarURL, initials as getInitials } from 'util/actors'

export const Avatar = ({
  actor,
  children,
  className,
  style,
  user, // Deprecated
  size, // dont render on DOM
  initialsColor, // dont render on DOM
  initialsBackground, // dont render on DOM
  initialsFontSize, // dont render on DOM
  radius, // dont render on DOM
  url: propUrl,
  ...rest
}) => {
  const url = propUrl || avatarURL(actor || user)
  const initials = getInitials(actor || user)

  return (
    <div
      className={className}
      style={{
        ...(url && {
          backgroundImage: `url(${url})`,
        }),
        ...style,
      }}
      {...rest}
    >
      {!url && initials}
      {children}
    </div>
  )
}

Avatar.propTypes = {
  // User object.
  // eslint-disable-next-line react/forbid-prop-types
  actor: PropTypes.object.isRequired,

  // Overrides color of initials
  initialsColor: PropTypes.string,

  // Overrides background color of initials
  initialsBackground: PropTypes.string,

  // Overrides font size of initials
  initialsFontSize: PropTypes.number,

  // Overrides radius of Avatar (image and initials)
  radius: PropTypes.string,

  // Size of the avatar (in px). Otherwise defaults to 100% HxW.
  // TODO As we standardize, we should define named sizes e.g. 'small', 'medium'
  size: PropTypes.number,
}

Avatar.defaultProps = {
  initialsColor: undefined,
  initialsBackground: undefined,
  initialsFontSize: undefined,
  radius: undefined,
  size: undefined,
}

Avatar.displayName = 'Avatar'

export default styled(Avatar)(
  ({
    size,
    radius = '50%',
    initialsColor = colors.lightBlue3,
    initialsBackground = colors.lightBlue4,
    initialsFontSize,
    url,
  }) => css`
    align-items: center;
    background-color: ${initialsBackground};
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: ${radius};
    color: ${!url ? initialsColor : 'transparent !important'};
    display: flex;
    font-size: ${initialsFontSize
      ? `${initialsFontSize}px`
      : size < 35 && `${Math.floor(size / 2)}px`};
    font-weight: ${fontWeights.medium};
    height: ${size ? `${size}px` : '100%'};
    justify-content: center;
    text-transform: uppercase;
    width: ${size ? `${size}px` : '100%'};
  `
)
